/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Theme } from "@mui/material";

export const navItemCategoryStyle = {
  navItemCategory: (theme: Theme) => ({
    padding: "1rem 0",
    margin: 0,
    color: theme.palette.text.primary,
    cursor: "pointer",
    border: "none",
    backgroundColor: "transparent",
    borderBottom: `1px solid ${theme.palette.divider}`,
    width: "100%",
    alignItems: "center",
    justifyContent: "space-between",
    [theme.breakpoints.up("lg")]: {
      position: "relative",
      paddingInline: "1rem",
      borderBottom: "none",
      height: "100%",
      transition: "background-color 50ms ease-in-out",
    },
  }),
  unactive: (theme: Theme) => ({
    [theme.breakpoints.up("lg")]: {
      "& + *": {
        display: "none",
      },
    },
  }),
  active: (theme: Theme) => ({
    [theme.breakpoints.up("lg")]: {
      "&::before": {
        content: "''",
        position: "absolute",
        bottom: 0,
        left: "1rem",
        height: "0.25rem",
        width: "calc(100% - 2rem)", // 2rem because of paddingInline in navItemCategory on desktop
        backgroundColor: theme.palette.secondary.main,
      },
    },
  }),
};
